/**
 * Utility functions for handling dates and timezones
 */

/**
 * Parse a UTC date string from API and return a Date object
 * Ensures the date is correctly interpreted as UTC, not local time
 */
export function parseUTCDate(dateString: string | null | undefined): Date | null {
  if (!dateString) return null;

  // If the string doesn't end with 'Z', add it to ensure UTC parsing
  const utcString = dateString.endsWith('Z') ? dateString : `${dateString}Z`;

  const date = new Date(utcString);

  // Validate the date
  if (isNaN(date.getTime())) {
    console.warn('Invalid date string:', dateString);
    return null;
  }

  return date;
}

/**
 * Format a UTC date string to local time string
 */
export function formatUTCToLocal(dateString: string | null | undefined, options?: Intl.DateTimeFormatOptions): string {
  const date = parseUTCDate(dateString);
  if (!date) return 'N/A';

  const defaultOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...options
  };

  return date.toLocaleString(undefined, defaultOptions);
}

/**
 * Check if a UTC date string represents a date in the past
 */
export function isDateExpired(dateString: string | null | undefined): boolean {
  const date = parseUTCDate(dateString);
  if (!date) return true;

  return date < new Date();
}
